<template>
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-flex lg12>
                <v-card>
                    <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter"
                        v-on:quickFilter="quickFilter"></hpo-filter>
                    <v-data-table :headers="headers" :items="items" :options.sync="pagination"
                        :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true"
                        :mobile-breakpoint="100">
                        <template v-slot:item="{ item }">
                            <tr :id="'r-' + item.ID">
                                <td>{{ item.ID }}</td>
                                <td>{{ item.Name }}</td>
                                <td class="text-center">
                                    <v-icon medium class="mr-2" @click="editItem(item)">fa-edit</v-icon>
                                    <v-icon medium @click="deleteItem(item.ID)">fa-trash-alt</v-icon>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="detailDialog" persistent max-width="300px">
            <v-form ref="validate_form" lazy-validation>
                <v-card>
                    <v-card-title>
                        <span class="title">Đối tác vận chuyển</span>
                    </v-card-title>
                    <v-card-text>
                        <v-layout row wrap pa-3>
                            <v-flex lg12 md12 sm12>
                                <v-text-field label="Tên đối tác" v-model="currentItem.Name"
                                    :rules="require_validation"></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" @click="detailDialog = false">Đóng</v-btn>
                        <v-btn @click="onCreateNewItem">Đồng ý</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
    </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";

export default {
    components: {
        "hpo-filter": Filtering
    },
    data() {
        return {
            headers: [
                {
                    text: "ID",
                    value: "ID",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tên đối tác",
                    value: "Name",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Thao tác",
                    value: "",
                    align: "center",
                    sortable: false,
                    filterable: false
                }
            ],
            pagination: { ...configs.PAGINATION, sortBy: ["ID"] },
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            viewName: "partner_list",
            filterConditions: [],
            quickFilterConditions: [],
            requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
            detailDialog: false,
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
    },
    computed: mapState({
        items: state => state.partner.all.data,
        total_rows: state => state.partner.all.total,
        loading: state => state.partner.loading,
        currentItem: state => state.partner.selected
    }),
    methods: {
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("partner/getList", param);
        },
        editItem: function (item) {
            this.$store.commit("partner/setDetail", {data: {...item}});
            this.detailDialog = true;
        },
        deleteItem: function (id) {
            window.getApp.$emit('REQUEST_DELETE_DATA', id);
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        createData() {
            this.$store.commit("partner/setDetail", {data: {ID: 0, Name: ''}});
            this.detailDialog = true;
        },
        onCreateNewItem() {
            this.$store.dispatch("partner/setDetail", {data: {...this.currentItem}, id: this.currentItem.ID});
            this.detailDialog = false;
        }
    },
    mounted() {
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_CREATE_DATA", this.createData);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("partner/removeDetail", id);
            setTimeout(this.filter_data, 200);
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA", this.createData);
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
    }
};
</script>
